import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Space,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Dropdown,
  Input,
  Row,
  Select,
  Spin,
  Collapse,
  Descriptions,
  Flex,
  Modal,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import {
  addMaterialRequest,
  cancelMaterialRequest,
  getMaterialRequestDetails,
  getStockItems,
  submitMaterialRequest,
  updateMaterialRequest,
} from '../../../network/materialRequest';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getWarehouse } from '../../../network/warehouse';
import { BiSolidShow } from 'react-icons/bi';
import { useSelector } from 'react-redux';
import { MdDelete, MdInventory, MdSubtitles } from 'react-icons/md';
import { PlusOutlined, DownOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { FaShoppingBasket } from 'react-icons/fa';
import { TiCancel } from 'react-icons/ti';
import ItemMaterialList from './ItemMaterialList';
import { getSalesOrderDetails } from '../../../network/salesOrder';
import HeadingApp from '../../../hooks/HeadingApp';
import { HiOutlineDocumentText } from 'react-icons/hi2';
const AddMaterialRequest = ({ t, edit, salesOrder }) => {
  console.log(edit, 'editfwejfiowejfiojweifjiew');

  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [nameItem, setNameItem] = useState();
  const [selectName, setSelectName] = useState(null);
  const [submitButton, setSubmitButton] = useState(false);
  const [dataStatus, setDataStatus] = useState(null);
  const [dataSource, setDataSource] = useState([
    {
      warehouse: form.getFieldValue('set_warehouse'),
    },
  ]);
  const navigate = useNavigate();
  const { id, idSalesOrder } = useParams();
  const { companyName, currentLang } = useSelector((state) => state.user);
  const client = useQueryClient();
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const { mutate: onAddMaterialWarehouse } = useMutation({
    mutationKey: ['addMaterialWarehouse'],
    mutationFn: (body) =>
      edit ? updateMaterialRequest(body, id) : addMaterialRequest(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      setSelectName(edit ? id : data?.data?.name);
      setSubmitButton(true);
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      client.invalidateQueries({ queryKey: [queryKeys.getMaterialRequest] });
      // form.resetFields();
      edit && dataStatus !== 0 && navigate('/material-request');
    },
    onError: (error) => {
      setLoadingAdd(false);
      message.error(error.response.data._server_messages);
      console.log('error:', error);
    },
  });
  const handleCancle = useMutation({
    mutationFn: (id) => cancelMaterialRequest('Material Request', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Cancled successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getMaterialRequest] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const handleSubmit = useMutation({
    mutationFn: (id) => submitMaterialRequest('Material Request', id),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Submitted successfully');
      submitButton && navigate('/material-request');
      client.invalidateQueries({ queryKey: [queryKeys.getMaterialRequest] });
    },
    onError: () => {
      setLoadingAdd(false);
      message.error('Something went wrong');
    },
  });
  const {
    data: materialwarehouseDetails,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [queryKeys.getMaterialRequest, id],
    queryFn: () => getMaterialRequestDetails(id),
    enabled: !!edit,
  });
  const { data: salesOrderDetails, isLoading: salesOrderLoading } = useQuery({
    queryKey: [queryKeys.getSalesOrderDetails, idSalesOrder],
    queryFn: () => getSalesOrderDetails(idSalesOrder),
    enabled: !!salesOrder,
  });
  const { data: warehouse } = useQuery({
    queryKey: [queryKeys.getWarehouse],
    queryFn: () =>
      getWarehouse({
        key: '',
        value: '',
      }),
    keepPreviousData: true,
  });
  // const { data: itemsList } = useQuery({
  //   queryKey: [queryKeys.getStockItems],
  //   queryFn: () => getStockItems(),
  //   keepPreviousData: true,
  // });
  const handleQtyChange = (qty, fieldName) => {
    const formValues = form.getFieldsValue();
    const rate = formValues.items[fieldName]?.rate || 0;
    const amount = qty * rate;

    form.setFieldsValue({
      items: formValues.items.map((item, index) =>
        index === fieldName ? { ...item, amount } : item
      ),
    });
  };

  useEffect(() => {
    if (edit && materialwarehouseDetails) {
      setDataStatus(materialwarehouseDetails?.data?.docstatus);
      setDataSource(
        materialwarehouseDetails?.data?.items?.map((item, index) => ({
          ...item,
          warehouse_Item: item?.warehouse,
          schedule_date: dayjs(item?.schedule_date),
          key: index,
        }))
      );
      form.setFieldsValue({
        ...materialwarehouseDetails?.data,
        transaction_date: dayjs(
          materialwarehouseDetails?.data?.transaction_date
        ),
        schedule_date: dayjs(materialwarehouseDetails?.data?.schedule_date),
        items: materialwarehouseDetails?.data?.items?.map((item) => ({
          ...item,
          warehouse_Item: item?.warehouse,
          schedule_date: dayjs(item?.schedule_date),
        })),
      });
    }
  }, [edit, materialwarehouseDetails, form]);
  useEffect(() => {
    if (salesOrder && salesOrderDetails?.message) {
      setDataStatus(salesOrderDetails?.message?.docstatus);
      setDataSource(
        salesOrderDetails?.message?.items?.map((item, index) => ({
          ...item,
          warehouse_Item: item?.warehouse,
          schedule_date: dayjs(item?.schedule_date),
          key: index,
        }))
      );
      form.setFieldsValue({
        ...salesOrderDetails?.message,
        transaction_date: dayjs(salesOrderDetails?.message?.transaction_date),
        schedule_date: dayjs(salesOrderDetails?.message?.schedule_date),
        items: salesOrderDetails?.message?.items?.map((item) => ({
          ...item,
          warehouse_Item: item?.warehouse,
          schedule_date: dayjs(item?.schedule_date),
        })),
      });
    }
  }, [salesOrder, salesOrderDetails, form]);
  const onFinish = (values) => {
    setLoadingAdd(true);
    onAddMaterialWarehouse({
      ...values,
      company: companyName,
      status: 'Pending',
      transaction_date: dayjs(values?.transaction_date).format('YYYY-MM-DD'),
      schedule_date: dayjs(values?.schedule_date).format('YYYY-MM-DD'),
      // items: values?.items?.map((item) => ({ ...item,warehouse: item?.warehouse_Item, schedule_date: dayjs(item?.schedule_date).format('YYYY-MM-DD')})),
      items: dataSource?.map((item) => ({
        ...item,
        warehouse: item?.warehouse_Item,
        schedule_date: dayjs(item?.schedule_date).format('YYYY-MM-DD'),
      })),
    });
  };
  if (isLoading || salesOrderLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  const itemsMenu = [
    {
      key: '1',
      label: (
        <Button
          size="small"
          type="text"
          // style={{ backgroundColor: '#28a745' }}
          style={{ width: '100%' }}
          icon={<MdSubtitles />}
          disabled={
            materialwarehouseDetails?.data?.docstatus === 0 ? false : true
          }
        >
          {t.submit}
        </Button>
      ),
      onClick: () => {
        handleSubmit.mutate(materialwarehouseDetails?.data?.name);
      },
    },
    {
      key: '2',
      label: (
        <Button
          size="small"
          type="text"
          icon={<TiCancel />}
          style={{ width: '100%' }}
          disabled={
            materialwarehouseDetails?.data?.docstatus === 1 ? false : true
          }
          danger
        >
          {t.cancel}
        </Button>
      ),
      onClick: () => {
        handleCancle.mutate(materialwarehouseDetails?.data?.name);
      },
    },

    {
      key: '3',
      label: (
        <Button
          size="small"
          type="text"
          style={{ width: '100%' }}
          icon={<FaShoppingBasket />}
          disabled={
            materialwarehouseDetails?.data?.docstatus === 1
              ? materialwarehouseDetails?.data?.material_request_type ===
                'Purchase'
                ? false
                : true
              : true
          }
          // disabled={(materialwarehouseDetails?.data?.docstatus !== 1 && materialwarehouseDetails?.data?.status !== 'Pending') }
          // disabled={true}
        >
          {t.purchaseOrder}
        </Button>
      ),
      onClick: () => {
        navigate(
          `/add-purchase-order-material/${materialwarehouseDetails?.data?.name}`
        );
      },
    },
    {
      key: '4',
      label: (
        <Button
          size="small"
          type="text"
          icon={<MdInventory />}
          style={{ width: '100%' }}
          disabled={
            materialwarehouseDetails?.data?.docstatus === 1
              ? materialwarehouseDetails?.data?.material_request_type !==
                'Purchase'
                ? false
                : true
              : true
          }
        >
          {t.AddStockEntry}
        </Button>
      ),
      onClick: () => {
        navigate(
          `/material/stock-entry-add/${materialwarehouseDetails?.data?.name}`
        );
      },
    },
  ];
  return (
    <>
      {/* <Heading
        title={t.Inventory}
        subTitle={edit ? t.editMaterialRequest : t.addMaterialRequest}
        path="/material-request"
      /> */}
      <HeadingApp
        nameTab={t.Inventory}
        title={t.JournalEntry}
        subTitle={edit ? t.editMaterialRequest : t.addMaterialRequest}
        icon={<HiOutlineDocumentText />}
      />
      <Card style={{ borderRadius: '0' }}>
        <Flex justify="end" align="center">
          {edit && (
            <Dropdown
              menu={{ items: itemsMenu }}
              trigger={['click']}
              arrow
              // onClick={() => setStatus(record)}
            >
              <Button size="small" type="text">
                {t.action}
                <DownOutlined />
              </Button>
            </Dropdown>
          )}
        </Flex>
        <Form
          form={form}
          name="add-Material-warehouse"
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            items: [{}],
          }}
          style={{
            marginTop: '20px',
          }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="material_request_type"
                    label={t.materialRequestType}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.materialRequestType}
                      style={{ width: '100%' }}
                      popupMatchSelectWidth={false}
                      onChange={(value, option) => {
                        console.log(option, 'option');
                      }}
                      options={[
                        {
                          value: 'Purchase',
                          label: t.Purchase,
                        },
                        {
                          value: 'Material Transfer',
                          label: t.MaterialTransfer,
                        },
                        {
                          value: 'Material Issue',
                          label: t.MaterialIssue,
                        },
                        {
                          value: 'Manufacture',
                          label: t.Manufacture,
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="transaction_date"
                    label={t.transactionDate}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.transactionDate}
                      format="YYYY-MM-DD"
                      disabledDate={(current) =>
                        current.endOf('d').valueOf() <
                        dayjs().endOf('d').valueOf()
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="schedule_date"
                    label={t.scheduleDate}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.scheduleDate}
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="set_warehouse"
                    label={t.setWarehouse}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select
                      placeholder={t.setWarehouse}
                      style={{ width: '100%' }}
                      popupMatchSelectWidth={false}
                      // onChange={(value) => {
                      //   const currentItems = form.getFieldValue('items') || [];
                      //   form.setFieldsValue({
                      //     items: currentItems.map((item) => ({ ...item, warehouse_Item: value })),
                      //   });
                      // }}
                      onChange={(value) => {
                        setDataSource(
                          dataSource.map((item) => {
                            return {
                              ...item,
                              warehouse: value,
                            };
                          })
                        );
                      }}
                      options={warehouse?.data?.map((item) => ({
                        value: item?.name,
                        label: item?.warehouse_name,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col span={24} className="items-form-add">
                  <ItemMaterialList
                    t={t}
                    form={form}
                    // itemsList={itemsList}
                    warehouse={warehouse}
                    setDataSource={setDataSource}
                    dataSource={dataSource}
                    selectedIndex={selectedIndex}
                    setSelectedIndex={setSelectedIndex}
                  />
                </Col>
              </Row>
              <div className="form-btns">
                <Button
                  type="primary"
                  ghost
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  {t.Cancel}
                </Button>
                <Button
                  type="primary"
                  loading={loadingAdd}
                  onClick={() => {
                    if (submitButton) {
                      setLoadingAdd(true);
                      handleSubmit.mutate(selectName);
                    } else {
                      form.submit();
                    }
                  }}
                >
                  {/* {edit ? t.edit : t.submit} */}
                  {submitButton ? t.submit : edit ? t.edit : t.Save}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};

export default AddMaterialRequest;
